import { Button, Input, Modal } from 'antd'
import { useEffect, useState } from 'react'
import { setGraphRenameRelationProps } from '../../Context/actions'
import { useGraphData } from '../../Context'

const RenameRelationModal = () => {
  const [{ renameRelationProps }, dispatch] = useGraphData()
  const [isVisible, setIsVisible] = useState(false)
  const [relKey, setRelKey] = useState(undefined)

  useEffect(() => {
    setIsVisible(true)
    renameRelationProps && setRelKey(renameRelationProps.key)
  }
  , [renameRelationProps])

  const rename = () => {
    renameRelationProps.promise.resolve({ key: relKey })
    setIsVisible(false)
  }
  const close = () => {
    renameRelationProps.promise.reject()
    dispatch(setGraphRenameRelationProps(undefined))
    setIsVisible(false)
  }

  const Footer = (
    <Button
      type="primary"
      onClick={rename}
    >
      Rename
    </Button>
  )

  return (
    <Modal
      title='Rename relation'
      visible={isVisible}
      onCancel={close}
      centered={true}
      mask={false}
      destroyOnClose={true}
      footer={Footer}
    >
      <Input
        value={relKey}
        onChange={(e) => setRelKey(e.target.value)}
        placeholder='Relation key'
      />
    </Modal>
  )
}

export default RenameRelationModal
